module.exports = __webpack_public_path__ + "static/img/no_friends.a1fb1afd.svg";